import { v4 as uuidv4 } from "uuid";
export class AssetCurrentReportModel {
    constructor() {
        this.id = uuidv4();
        this.assetCode = "";
        this.assetCategory = "";
        this.name = "";
        this.assetStatus = "";
        this.employeeName = "";
        this.teamName = "";
    }
}
export default class AssetCurrentReport extends AssetCurrentReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
